import { type TrackEventOptions, useGtm } from '@gtm-support/vue-gtm';

import type { LoggedInUser } from '@/plugins/authentication/lib/Authentication';

export function assertGtmIdList(list: (string | undefined)[]): asserts list is string[] {
  list.forEach(id => {
    if (id === undefined || id.length === 0) {
      throw new Error('Le GTM id devrait être une string non vide.');
    }
  });
}

export function trackEvent(eventOptions: TrackEventOptions): void {
  const gtm = useGtm();

  if (gtm === undefined) {
    throw new Error('GTM introuvable.');
  }

  gtm.trackEvent(eventOptions);
}

export function trackAuthSuccess(user: LoggedInUser): void {
  if (!user.codeDistributeur) {
    console.warn('codeDistributeur is missing');
  }

  trackEvent({
    event: 'auth-success',
    uid: user.id,
    codeProduction: user.codeDistributeur,
  });
}
